function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M1.558 0L0 1.559l5.445 5.445L0 12.448l1.558 1.551L7 8.559l5.445 5.444L14 12.448 8.558 7 14 1.559 12.445.004 7 5.449z"
});

var SvgIconX = function SvgIconX(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 14 13.999"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNCAxMy45OTkiPjxkZWZzPjwvZGVmcz48cGF0aCBkPSJNMTguMywxNi45NDEsMTYuNzQyLDE4LjVsNS40NDUsNS40NDUtNS40NDUsNS40NDRMMTguMywzMC45NCwyMy43NDIsMjUuNWw1LjQ0NSw1LjQ0NCwxLjU1NS0xLjU1NUwyNS4zLDIzLjk0MSwzMC43NDIsMTguNWwtMS41NTUtMS41NTUtNS40NDUsNS40NDVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTYuNzQyIC0xNi45NDEpIi8+PC9zdmc+";
export { SvgIconX as ReactComponent };